export const gtmEventTypes = {
  SELECT_FILTER_OPTION: 'FED-MCB-001',
  CLICK_ADDRESS: 'FED-MCB-002',
  CLICK_PHONE: 'FED-MCB-003',
  CLICK_WEBSITE: 'FED-MCB-004',
  SELECT_DEALER_NAME: 'FED-MCB-005',
  SELECT_DEALER_DEPARTMENT: 'FED-MCB-006',
  CLICK_CTA: 'FED-MCB-007',
}

export const gtmEvents = {
  [gtmEventTypes.SELECT_FILTER_OPTION]: ({option}) => ({
    type: gtmEventTypes.SELECT_FILTER_OPTION,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_FILTER_OPTION,
    pageCategory: 'Dealer Map Block',
    pageAction: `Dealer Map Block - Selected "${option.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_ADDRESS]: ({dealerName, departments, address}) => ({
    type: gtmEventTypes.CLICK_ADDRESS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_ADDRESS,
    pageCategory: 'Dealer Map Block',
    pageAction: `Dealer Map Block - ${dealerName} - Clicked "ADDRESS ${address.toUpperCase()}" - ${departments.toString()} - ${address}`,
  }),
  [gtmEventTypes.CLICK_PHONE]: ({
                                  dealerName, phone, departments, address,
                                }) => ({
    type: gtmEventTypes.CLICK_PHONE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_PHONE,
    pageCategory: 'Dealer Map Block',
    pageAction: `Dealer Map Block - ${dealerName} - Clicked "PHONE ${phone}" - ${departments.toString()} - ${address}`,
  }),
  [gtmEventTypes.CLICK_WEBSITE]: ({
                                    dealerName, website, departments, address,
                                  }) => ({
    type: gtmEventTypes.CLICK_WEBSITE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_WEBSITE,
    pageCategory: 'Dealer Map Block',
    pageAction: `Dealer Map Block - ${dealerName} - Clicked "WEBSITE ${website.toUpperCase()}" - ${departments.toString()} - ${address}`,
  }),
  [gtmEventTypes.SELECT_DEALER_NAME]: ({dealerName, department, address}) => ({
    type: gtmEventTypes.SELECT_DEALER_NAME,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_DEALER_NAME,
    pageCategory: 'Dealer Map Block',
    pageAction: `Dealer Map Block - Selected "${dealerName}" - ${department.toUpperCase()} - ${address}`,
  }),
  [gtmEventTypes.SELECT_DEALER_DEPARTMENT]: ({dealerName, department, address}) => ({
    type: gtmEventTypes.SELECT_DEALER_DEPARTMENT,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_DEALER_DEPARTMENT,
    pageCategory: 'Dealer Map Block',
    pageAction: `Dealer Map Block - ${dealerName} - Clicked "DEPARTMENT MENU - ${department.toUpperCase()}" - ${address}`,
  }),
  [gtmEventTypes.CLICK_CTA]: ({
                                dealerName, ctaName, departments, address,
                              }) => ({
    type: gtmEventTypes.CLICK_CTA,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_CTA,
    pageCategory: 'Dealer Map Block',
    pageAction: `Dealer Map Block - ${dealerName} - Clicked "CTA BUTTON ${ctaName.toUpperCase()}" - ${departments.toString()} - ${address}`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/map-select-state-duck.js